import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Employees from "@/pages/Employees";
import ImportEmployees from "@/pages/ImportEmployees";
import OpeningBalances from "@/pages/OpeningBalances";
import Deduction from "@/pages/Deduction";
import SalaryCalculator from "@/pages/SalaryCalculator";
import FinalizePayroll from "@/pages/FinalizePayroll";
import Payroll from "@/pages/Payroll";
import AddAdvance from "@/pages/AddAdvance";
import Payslips from "@/pages/Payslips";
import { ADVANCE_ONLY } from "@/lib/format";
import Ledger from "@/pages/Ledger";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import BackupDownload from "@/pages/BackupDownload";
import { Loader2 } from "lucide-react";

function Protected({ children, advanceOnly = false }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-blue-800" />
      </div>
    );
  if (!user) {
    if (window.location.pathname.startsWith("/backup-download/")) sessionStorage.setItem("after_login", window.location.pathname);
    return <Navigate to="/login" replace />;
  }
  if (ADVANCE_ONLY.includes(user.role) && !advanceOnly) return <Navigate to="/add-advance" replace />;
  return <Layout>{children}</Layout>;
}

export const homeFor = (user) => (ADVANCE_ONLY.includes(user?.role) ? "/add-advance" : "/");

function LoginRoute() {
  const { user } = useAuth();
  if (user) return <Navigate to={sessionStorage.getItem("after_login") || homeFor(user)} replace />;
  return <Login />;
}

const page = (el) => <Protected>{el}</Protected>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/" element={page(<Dashboard />)} />
          <Route path="/employees" element={page(<Employees />)} />
          <Route path="/import" element={page(<ImportEmployees />)} />
          <Route path="/opening-balances" element={page(<OpeningBalances />)} />
          <Route path="/add-advance" element={<Protected advanceOnly><AddAdvance /></Protected>} />
          <Route path="/deduction" element={page(<Deduction />)} />
          <Route path="/salary" element={page(<SalaryCalculator />)} />
          <Route path="/finalize-advance" element={page(<FinalizePayroll />)} />
          <Route path="/finalize-payroll" element={page(<Payroll />)} />
          <Route path="/payslips" element={page(<Payslips />)} />
          <Route path="/ledger" element={page(<Ledger />)} />
          <Route path="/ledger/:code" element={page(<Ledger />)} />
          <Route path="/reports" element={page(<Reports />)} />
          <Route path="/settings" element={page(<Settings />)} />
          <Route path="/backup-download/:token" element={page(<BackupDownload />)} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
